console.log("CART PAGE TRACKING");

function initCartPageTracking() {
  function formatProductData(productData, index) {
    const { sku, name, vendor, product_type, variant_title, price, quantity } = productData
    return {
      item_id: sku,
      item_name: name,
      affiliation: Shopify.shop,
      currency: Shopify.currency.active,
      discount: trackingFormatPrice(trackingGetProductDiscount(productData)),
      index,
      item_brand: vendor,
      item_category: product_type,
      item_list_id: "all",
      item_list_name: "All",
      item_variant: variant_title,
      price: trackingFormatPrice(price),
      quantity: quantity
    }
  }

  function getCartProductData() {
    const productEles = [...document.querySelectorAll('.cart-item .item-variant-id')]
    const items = productEles.map((ele, index) => formatProductData(JSON.parse(ele.getAttribute('variant-tracking-data')), index));
    return items;
  }

  function handleViewCart() {
    const data = getCartProductData();
    let value = document.querySelector('#checkout .btn-total').innerHTML.trim().replace("£", "").replace("$", "").replace("€", "");
    // const value = trackingFormatPrice(
    //   data.reduce(
    //     (previous, current) => previous + current.price,
    //     0
    //   ), 1
    // )
    // const value =
    
    pushToDataLayer("view_cart", data, null, Shopify.currency.active, value);
  }

  handleViewCart();
}

function cartProductAmountChange(lineItemData, collectionData, increase, quantityChange) {
  console.log(lineItemData);

  dataLayer.push({
    event: increase ? "dlv_add_to_cart" : "remove_from_cart",
    ecommerce: {
      product_type: "otp",
      delivery_frequency: null,
      items: [          
        {
          item_id: lineItemData.sku,
        item_name: lineItemData.product_title,
        affiliation: Shopify.shop,
        currency: Shopify.currency.active,
        discount: lineItemData.line_level_total_discount,
        index: null,
        item_brand: lineItemData.vendor,
        item_category: lineItemData.product_type,
        item_list_id: "all", //lineItemData
        item_list_name: "All", //lineItemData
        item_variant: lineItemData.variant_title,
        price: trackingFormatPrice(lineItemData.price),
        quantity: quantityChange || lineItemData.quantity
        }
      ]
    }
});


}

function removeLineFromCart(lineItemData) {

  dataLayer.push({
    event: "remove_from_cart",
    ecommerce: {
      product_type: "otp",
      delivery_frequency: null,
      items: [          
        {
          item_id: lineItemData.sku,
          item_name: lineItemData.product_title,
          affiliation: Shopify.shop,
          currency: Shopify.currency.active,
          discount: lineItemData.line_level_total_discount,
          index: null,
          item_brand: lineItemData.vendor,
          item_category: lineItemData.product_type,
          item_list_id: "all", //lineItemData
          item_list_name: "All", //lineItemData
          item_variant: lineItemData.variant_title,
          price: trackingFormatPrice(lineItemData.price),
          quantity: lineItemData.quantity
        }
      ]
    }
});

}

initCartPageTracking();